import { useState, useEffect } from 'react';
import type { LiveStatus } from '../../lib/types';

export function useRuntimeStatus(appId: string) {
  const [runtimeStatus, setRuntimeStatus] = useState<LiveStatus>('stopped');
  const [starting, setStarting] = useState(false);

  useEffect(() => {
    fetch('/.compass/runtime.json')
      .then((r) => r.json())
      .then((data: { apps: Array<{ appId: string; healthStatus: LiveStatus }> }) => {
        const st = data.apps.find((a) => a.appId === appId);
        if (st) setRuntimeStatus(st.healthStatus);
      })
      .catch(() => {});
  }, [appId]);

  const startApp = async () => {
    setStarting(true);
    setRuntimeStatus('starting');
    try {
      const resp = await fetch('/.compass/start', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ appId }),
      });
      const data = (await resp.json()) as { healthStatus?: LiveStatus };
      setRuntimeStatus(data.healthStatus ?? 'failed');
    } catch {
      setRuntimeStatus('failed');
    } finally {
      setStarting(false);
    }
  };

  const stopApp = async () => {
    await fetch('/.compass/stop', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ appId }),
    });
    setRuntimeStatus('stopped');
  };

  return { runtimeStatus, starting, startApp, stopApp };
}
